export default "__VITE_ASSET__BN4SWIa$__"